// src/pages/RaonAuthResult.js

import { useEffect } from 'react';
import { API_BASE_URL } from '../config/config';
import { AuthRelay } from '../components/AuthLayout';

const safeSetLocalStorage = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn('localStorage 저장 실패', e);
    return false;
  }
};

const RaonAuthResult = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const result = {
      name: params.get('name'),
      tel_no: params.get('tel_no'),
      birthday: params.get('birthday'),
      sex_cd: params.get('sex_cd'),
      di: params.get('di'),
      eci: params.get('eci'),
      resultCode: params.get('resultCode'),
      resultMsg: params.get('resultMsg'),
    };
    
    // authType과 userIndex 파라미터 추가로 읽기
    const authType = params.get('authType');
    const userIndex = params.get('userIndex');
    
    // console.log('[RAON AuthResult] URL params:', {
    //   name: result.name,
    //   tel_no: result.tel_no,
    //   birthday: result.birthday,
    //   sex_cd: result.sex_cd,
    //   di: result.di,
    //   eci: result.eci,
    //   authType,
    //   userIndex,
    //   allParams: Object.fromEntries(params.entries())
    // });
    
    // console.log('[RAON AuthResult] Current URL:', window.location.href);
    // console.log('[RAON AuthResult] Search params:', window.location.search);
    
    const debugLog = {
      result,
      opener: !!window.opener,
      origin: window.location.origin,
      timestamp: new Date().toISOString()
    };
    
    const saveAndClose = () => {
      // console.log('[RAON popup] set raon_auth_result:', result);
      safeSetLocalStorage('raon_auth_result', JSON.stringify({ 
        ...result, 
        authType, 
        userIndex: userIndex ? parseInt(userIndex) : undefined,
        debug: debugLog 
      }));
      setTimeout(() => window.close(), 500);
    };
    
    if (window.opener) {
      try {
        window.opener.postMessage(
            {
              rslt_name: result.name,
              tel_no: result.tel_no,
              birthday: result.birthday,
              sex_cd: result.sex_cd,
              di: result.di,
              eci: result.eci,
              resultCode: result.resultCode,
              resultMsg: result.resultMsg,
              authType: authType || 'password_reset',
              userIndex: userIndex ? parseInt(userIndex) : undefined,
              debug: debugLog
            },
            API_BASE_URL  // ← 이 부분!!
          );          
        // postMessage 성공해도 fallback 저장 및 딜레이 닫기 보장
        saveAndClose();
      } catch (e) {
        debugLog.error = e?.message || e;
        saveAndClose();
        return;
      }
    } else {
      debugLog.opener = false;
      saveAndClose();
      return;
    }
  }, []);

  return <AuthRelay title="간편인증 결과를 처리 중입니다..." description="잠시 후 이 창이 자동으로 닫혀요." />;
};

export default RaonAuthResult; 